import type { JSX } from 'react'

export const FacebookCenteredSolidIcon = (): JSX.Element => (
  <use href='#facebookCenteredSolidIcon' height='100%' width='100%' />
)
